export default "__VITE_ASSET__CheOpTdI__"